import { createSlice } from '@reduxjs/toolkit';
import { enableMapSet } from 'immer';
enableMapSet();

const initialState = {};

const flowEditorSlice = createSlice({
  name: 'flowEditor',
  initialState,
  reducers: {
    setFlowEditorModelData: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    setFlowIsLoading(state, action) {
      state.isloading = action?.payload?.isloading;
    },
    clearFlowEditor: () =>
    {
   return initialState
    }
  
  },
});

const { reducer, actions } = flowEditorSlice;

export const { setFlowEditorModelData , clearFlowEditor} = actions;
export default reducer;
